"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import SourceCard from "@/app/(components)/generics/cards/SourceCard/SourceCard";
import IconExternalLink from "@/app/(components)/generics/Icons/IconExternalLink";
import IconLinkedIn from "@/app/(components)/generics/Icons/IconLinkedIn";
import { useExtensionInstalled } from "@/app/hooks/useExtensionInstalled";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { sendingGuideStepKeys } from "./SendingGuideCard.logic";

type Props = {
  params: PageParams;
  isConnected: boolean;
};

export default function SendingGuideCard(props: Props) {
  const T = useT();
  const { params, isConnected } = props;

  const detectedInstall = useExtensionInstalled();

  if (isConnected && detectedInstall === null) {
    return null;
  }

  const isInstalled = isConnected ? detectedInstall : null;

  const renderActions = () => {
    if (!isConnected) {
      return (
        <Button
          min={true}
          isLink={false}
          type={ButtonType.PRIMARY}
          text={T(TKey.MESSAGES_CONTENT_GUIDE_SIGNUP) as string}
          onClick={() => ModalStore.getState().openSignUp(params)}
        />
      );
    }

    if (isInstalled === false) {
      return (
        <Button
          params={params}
          min={true}
          isLink={true}
          href={URLs.extensionStore()}
          external={true}
          type={ButtonType.PRIMARY}
          text={T(TKey.MESSAGES_CONTENT_GUIDE_INSTALL) as string}
          afterIcon={<IconExternalLink size={16} />}
        />
      );
    }

    return null;
  };

  return (
    <SourceCard
      icon={<IconLinkedIn />}
      title={T(TKey.MESSAGES_CONTENT_GUIDE_TITLE) as string}
      description={
        T(
          isConnected ? TKey.MESSAGES_CONTENT_GUIDE_DESCRIPTION : TKey.MESSAGES_CONTENT_GUIDE_LEAD,
        ) as string
      }
      benefits={sendingGuideStepKeys(isInstalled).map((key) => T(key) as string)}
      numberedBenefits={true}
      actions={renderActions()}
    />
  );
}
